<template>
  <ul class="text-black">
    <li v-for="item in items">
      <span class="name font-red">{{item.content}} </span>
    </li>
  </ul>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          content: "Créditos 1"
        },
        {
          content: "Créditos 2"
        },
        {
          content: "Créditos 3"
        },
        {
          content: "Créditos 4"
        }
      ]
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "../../sass/helpers/variables.scss";
</style>



// WEBPACK FOOTER //
// Creditos.vue?473aee85